export type CorrelationIds = {
    sessionId: string | null;
    journeyId: string | null;
};

// Mirrors the register, login/request and login validators in
// irl-runtime-services: Joi.string().guid({ version: ['uuidv4', 'uuidv5'] }).
// Kept to the canonical hyphenated form, which is all this app ever mints.
const BACKEND_CORRELATION_GUID =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[45][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isBackendCorrelationGuid(value: unknown): value is string {
    return typeof value === "string" && BACKEND_CORRELATION_GUID.test(value);
}

/**
 * Put sessionId/journeyId on a request payload, preferring what the caller set.
 *
 * authStore is shared with the React app on the same origin, and a partner
 * launch stores its own `sess_<hex>` / `jrn_<hex>` ids there. The user-auth
 * endpoints reject anything but a GUID with a 400, so with `guidOnly` a
 * non-GUID id is left off the payload (both fields are optional server-side)
 * rather than failing the player's registration or sign-in. Endpoints that
 * accept any string (events) keep the partner ids for journey correlation.
 */
export function applyCorrelationIds(
    payload: Record<string, unknown>,
    ids: CorrelationIds,
    options?: { guidOnly?: boolean }
): Record<string, unknown> {
    for (const key of ["sessionId", "journeyId"] as const) {
        const candidates = [payload[key], ids[key]];
        payload[key] = options?.guidOnly
            ? candidates.find(isBackendCorrelationGuid)
            : candidates.find(Boolean);
    }
    return payload;
}
